import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';

const HumorContent = ({ content, onReact }) => {
  const [selectedReaction, setSelectedReaction] = useState('');
  const [reactionCounts, setReactionCounts] = useState({
    '😂': Math.floor(Math.random() * 200) + 50,
    '❤️': Math.floor(Math.random() * 150) + 30,
    '👍': Math.floor(Math.random() * 180) + 40,
    '🔥': Math.floor(Math.random() * 120) + 25
  });

  const reactions = ['😂', '❤️', '👍', '🔥'];

  const handleReaction = (emoji) => {
    if (selectedReaction === emoji) return;

    setReactionCounts(prev => ({
      ...prev,
      [emoji]: prev?.[emoji] + 1
    }));
    setSelectedReaction(emoji);

    if (onReact) {
      onReact(emoji);
    }
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl flex items-center justify-center flex-shrink-0 bg-success/10">
          <Icon name="Smile" size={24} color="var(--color-success)" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-4 md:mb-5">
            Günün Eğlencesi
          </h3>
          <div className="p-6 md:p-8 lg:p-10 rounded-xl bg-gradient-to-br from-accent/5 to-success/5 border border-border">
            <p className="text-base md:text-lg lg:text-xl text-foreground leading-relaxed">
              {content || 'Trafik polisi şoföre sorar: "Neden bu kadar hızlı gidiyorsunuz?" Şoför: "Frenlerim bozuk, eve çabuk varmam lazım!" 😄'}
            </p>
          </div>
        </div>
      </div>
      <div>
        <p className="text-sm md:text-base text-muted-foreground mb-3 md:mb-4 text-center">
          Tepkini göster
        </p>
        <div className="grid grid-cols-4 gap-3 md:gap-4">
          {reactions?.map((emoji) => (
            <button
              key={emoji}
              onClick={() => handleReaction(emoji)}
              className={`p-4 md:p-5 lg:p-6 rounded-xl border-2 transition-all duration-250 ${
                selectedReaction === emoji
                  ? 'border-primary bg-primary/10 scale-110' :'border-border hover:border-primary/50 bg-card hover:scale-105'
              }`}
            >
              <div className="text-3xl md:text-4xl lg:text-5xl mb-2 text-center">
                {emoji}
              </div>
              <p className="text-xs md:text-sm text-center font-medium text-muted-foreground">
                {reactionCounts?.[emoji]}
              </p>
            </button>
          ))}
        </div>
      </div>
      {selectedReaction && (
        <div className="text-center">
          <p className="text-sm md:text-base text-success flex items-center justify-center gap-2">
            <Icon name="CheckCircle" size={16} />
            Tepkin kaydedildi!
          </p>
        </div>
      )}
    </div>
  );
};

export default HumorContent;